export function getVideoType(videoPath) {
  if (!videoPath) return "";

  const extension = videoPath.split(".").pop().toLowerCase();

  switch (extension) {
    case "mp4":
      return "video/mp4";
    case "webm":
      return "video/webm";
    case "ogg":
    case "ogv":
      return "video/ogg";
    default:
      return "video/mp4";
  }
}
